import { IEmail } from "./email";

export interface IEmailResponse {
    data: {
        success: boolean;
        message: string;
        results: Array<IEmail>;
    }
}